import gitData from './data/git.json';
import javascriptData from './data/javascript.json';
import markupData from './data/markup.json';
import nodejsData from './data/nodejs.json';
import reactData from './data/react.json';

const THEME_KEY = 'education_theme';

function getSavedTheme() {
  const saved = localStorage.getItem(THEME_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return 'dark'; // Dark theme is default
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  if (document.body) {
    document.body.setAttribute('data-theme', theme);
  }
  const btn = document.querySelector('#theme-toggle');
  if (btn) {
    btn.setAttribute('title', theme === 'dark' ? 'Включить светлую тему' : 'Включить темную тему');
    btn.setAttribute('aria-label', theme === 'dark' ? 'Включить светлую тему' : 'Включить темную тему');
    btn.innerHTML = theme === 'dark'
      ? '<span class="theme-icon">🌙</span>'
      : '<span class="theme-icon">☀️</span>';
  }
}

function toggleTheme() {
  const current = document.documentElement.getAttribute('data-theme') || 'dark';
  const next = current === 'dark' ? 'light' : 'dark';
  localStorage.setItem(THEME_KEY, next);
  applyTheme(next);
}

// Apply theme immediately
applyTheme(getSavedTheme());

function init() {
  // Ensure theme UI is synced
  applyTheme(getSavedTheme());

  const themeBtn = document.querySelector('#theme-toggle');
  if (themeBtn) {
    themeBtn.addEventListener('click', toggleTheme);
  }

  const titleElem = document.querySelector('title');
  const pageTitle = titleElem ? titleElem.innerText.trim() : '';

  const videoList = document.querySelector('#videos');
  const materialsList = document.querySelector('#materials');
  const topArrow = document.querySelector('#top-arrow');
  const navList = document.querySelectorAll('#nav-list>li>a');

  const getListContent = (data = []) => {
    if (!Array.isArray(data) || data.length === 0) {
      return '<li><span>Материалы скоро появятся</span></li>';
    }
    return data
      .map(({ title, url }) => `<li><a href="${url}" target="_blank" rel="noopener noreferrer">${title}</a></li>`)
      .join('');
  };

  const renderList = (data) => {
    if (!data) return;
    const { videos, materials } = data;
    if (videoList) videoList.innerHTML = getListContent(videos);
    if (materialsList) materialsList.innerHTML = getListContent(materials);
  };

  switch (pageTitle) {
    case 'Markup':
      if (navList[0]) navList[0].classList.add('active__link');
      renderList(markupData);
      break;
    case 'JavaScript':
      if (navList[1]) navList[1].classList.add('active__link');
      renderList(javascriptData);
      break;
    case 'React':
      if (navList[2]) navList[2].classList.add('active__link');
      renderList(reactData);
      break;
    case 'NodeJS':
      if (navList[3]) navList[3].classList.add('active__link');
      renderList(nodejsData);
      break;
    case 'Git':
      if (navList[4]) navList[4].classList.add('active__link');
      renderList(gitData);
      break;
    default:
      break;
  }

  const onScroll = () => {
    if (!topArrow) return;
    if (document.body.scrollTop > 30 || document.documentElement.scrollTop > 30) {
      topArrow.classList.add('visible');
    } else {
      topArrow.classList.remove('visible');
    }
  };

  const handleOnTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  if (topArrow) {
    topArrow.addEventListener('click', handleOnTop);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
